import TextField from "@material-ui/core/TextField";
import DatePicker from "@material-ui/lab/DatePicker";
import moment from "moment";
import React, {useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionChangeField } from "../../store/invoice/create/actions";
import { FieldDateOfReceiptFC } from "./types";

const FieldDateOfReceipt: FieldDateOfReceiptFC = ({ saving }) => {
  const dispatch = useDispatch();
  const { value, error } = useSelector(
    ({
      invoice: {
        create: { invoice, errors },
      },
    }) => ({
      value: invoice?.dateOfReceipt ?? null,
      error: errors?.dateOfReceipt ?? false,
    })
  );
    const [openData, setOpenData] = useState(false);


    return (
    <DatePicker
      value={value}
      open={openData}
      onOpen={() => setOpenData(true)}
      onClose={() => setOpenData(false)}
      disabled={saving}
      clearable
      minDate={moment()}
      disablePast
      onChange={(date) => {
        dispatch(
          actionChangeField({
            field: "dateOfReceipt",
            value: date ? moment(date).toDate() : null,
          })
        );
      }}
      InputProps={{
        error,
        fullWidth: true,
      }}
      renderInput={(params) => <TextField type="datetime-local"
                                          inputProps={{
                                              min: new Date().toISOString().slice(0, 16),
                                          }}
                                          {...params}
                                          onClick={(e) => setOpenData(true)}
                                          fullWidth />}
    />
  );
};

export default FieldDateOfReceipt;
